import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["authedUser"];
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { useGetUserProfile } from '../../data/userProfile';
import { EditProfileForm } from './EditProfileForm';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditProfileContainer(_ref) {
  let {
      authedUser
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data: currentProfileData,
    loading,
    error
  } = useGetUserProfile(authedUser.id);
  const userProfile = currentProfileData === null || currentProfileData === void 0 ? void 0 : currentProfileData.user_profile;
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {});
  }
  if (error || !userProfile) {
    throw new Error('Error fetching user profile');
  }
  const isCreating = userProfile.profileExists === false;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    blockSize: "100vh",
    overflow: "auto",
    children: /*#__PURE__*/_jsx(EditProfileForm, Object.assign({
      authedUser: authedUser,
      isCreating: isCreating,
      userProfile: currentProfileData.user_profile
    }, rest))
  });
}